/* ==========================================================================
   SOFT PLAYERS CLUB - Find Your Role quiz
   One question per screen, scores answers by role number, shows the
   matching result. Share = native share sheet or copy link.
   Save = designed card image, or a card drawn on canvas.
   ========================================================================== */
(function () {
  if (window.SoftPlayersQuiz) return;
  window.SoftPlayersQuiz = true;

  function pad(n) {
    var s = String(parseInt(n, 10));
    return s.length < 2 ? '0' + s : s;
  }

  function track(name, data) {
    if (window.SoftPlayersClub && window.SoftPlayersClub.track) window.SoftPlayersClub.track(name, data || {});
  }

  function wrapLines(ctx, text, maxWidth) {
    var words = text.split(/\s+/);
    var lines = [];
    var line = '';
    words.forEach(function (w) {
      var test = line ? line + ' ' + w : w;
      if (ctx.measureText(test).width > maxWidth && line) {
        lines.push(line);
        line = w;
      } else {
        line = test;
      }
    });
    if (line) lines.push(line);
    return lines;
  }

  function drawCard(cardEl, serif) {
    var W = 1080;
    var H = 1350;
    var c = document.createElement('canvas');
    c.width = W;
    c.height = H;
    var x = c.getContext('2d');
    var bg = '#101a28';
    var fg = '#f2ede5';
    var sans = getComputedStyle(cardEl).fontFamily || 'sans-serif';
    function spacing(v) { if ('letterSpacing' in x) x.letterSpacing = v; }
    function text(t, font, y, ls) {
      x.font = font;
      spacing(ls || '0px');
      x.fillText(t, W / 2, y);
    }

    x.fillStyle = bg;
    x.fillRect(0, 0, W, H);
    x.strokeStyle = 'rgba(242,237,229,.45)';
    x.lineWidth = 2;
    x.strokeRect(48, 48, W - 96, H - 96);

    x.fillStyle = fg;
    x.textAlign = 'center';
    x.textBaseline = 'middle';

    var get = function (sel) {
      var el = cardEl.querySelector(sel);
      return el ? el.textContent.trim() : '';
    };

    text(get('.sp-quiz__card-brand').toUpperCase(), '500 34px ' + sans, 200, '10px');
    text(get('.sp-quiz__card-club').toUpperCase(), '400 24px ' + sans, 256, '8px');
    text(get('.sp-quiz__card-num').toUpperCase(), '400 26px ' + sans, 520, '8px');

    x.font = '400 92px ' + serif;
    spacing('0px');
    var name = get('.sp-quiz__card-name').toUpperCase();
    var lines = wrapLines(x, name, W - 260);
    var lh = 100;
    var startY = 690 - ((lines.length - 1) * lh) / 2;
    lines.forEach(function (l, i) { x.fillText(l, W / 2, startY + i * lh); });

    var tag = get('.sp-quiz__card-line');
    if (tag) {
      x.font = 'italic 400 40px ' + serif;
      var tl = wrapLines(x, tag, W - 300);
      var ty = startY + lines.length * lh + 30;
      tl.forEach(function (l, i) { x.fillText(l, W / 2, ty + i * 50); });
    }

    text(get('.sp-quiz__card-sign'), '400 64px "SP Amoresa", ' + serif, 1130, '0px');
    return c;
  }

  function deliverFile(blob, filename, title) {
    var file;
    try { file = new File([blob], filename, { type: blob.type || 'image/png' }); } catch (e) { file = null; }
    if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
      return navigator.share({ files: [file], title: title }).catch(function () {});
    }
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
    return Promise.resolve();
  }

  function initQuiz(root) {
    if (root.dataset.spQuizBound) return;
    root.dataset.spQuizBound = '1';

    var screens = Array.prototype.slice.call(root.querySelectorAll('.sp-quiz__screen'));
    var intro = root.querySelector('[data-screen="intro"]');
    var questions = screens.filter(function (s) { return s.dataset.screen === 'question'; });
    var results = screens.filter(function (s) { return s.dataset.screen === 'result'; });
    var answers = [];
    var current = -1;
    var started = false;
    var status = null;
    var serif = getComputedStyle(root).getPropertyValue('--sp-serif').trim() || 'Cormorant, Georgia, serif';

    function show(el, focus) {
      screens.forEach(function (s) {
        var on = s === el;
        s.hidden = !on;
        s.classList.toggle('is-active', on);
      });
      var top = root.getBoundingClientRect().top;
      if (top < -10 || top > window.innerHeight * 0.5) {
        root.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      if (focus) {
        var h = el.querySelector('legend, h1, h2');
        if (h) {
          h.setAttribute('tabindex', '-1');
          h.focus({ preventScroll: true });
        }
      }
    }

    function markSelected(i) {
      var q = questions[i];
      if (!q) return;
      q.querySelectorAll('[data-quiz-answer]').forEach(function (b) {
        var on = !!(answers[i] && answers[i].n === b.dataset.quizAnswer);
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function goQuestion(i) {
      current = i;
      markSelected(i);
      show(questions[i], true);
    }

    function start() {
      if (!started) {
        started = true;
        track('sp_quiz_start');
      }
      answers = [];
      if (questions.length) goQuestion(0);
    }

    function score() {
      var totals = {};
      var order = [];
      answers.forEach(function (a) {
        if (!a) return;
        a.roles.forEach(function (r) {
          totals[r] = (totals[r] || 0) + 1;
          order.push(r);
        });
      });
      var best = null;
      var max = -1;
      Object.keys(totals).forEach(function (r) {
        if (totals[r] > max || (totals[r] === max && order.lastIndexOf(r) > order.lastIndexOf(best))) {
          max = totals[r];
          best = r;
        }
      });
      return best;
    }

    function findResult(num) {
      var p = pad(num);
      for (var i = 0; i < results.length; i++) if (results[i].dataset.role === p) return results[i];
      return null;
    }

    function showResult(num, fromLink) {
      var el = findResult(num) || results[0];
      if (!el) return;
      current = questions.length;
      status = el.querySelector('.sp-quiz__status');
      if (status) status.textContent = '';
      show(el, true);
      var role = el.dataset.role;
      if (!fromLink) {
        track('sp_quiz_complete', { role: role, role_name: el.dataset.roleName });
        if (window.SoftPlayersClub && window.SoftPlayersClub.setRole) window.SoftPlayersClub.setRole(role);
        try {
          var u = new URL(window.location.href);
          u.searchParams.delete('q1');
          u.searchParams.set('role', role);
          history.replaceState(null, '', u.toString());
        } catch (e) {}
      }
    }

    function shareUrl(role) {
      return window.location.origin + window.location.pathname + '?role=' + role;
    }

    function share(el) {
      var role = el.dataset.role;
      var name = el.dataset.roleName || '';
      var title = root.dataset.shareTitle || '';
      var text = (root.dataset.shareText || '').replace('[role]', name);
      var url = shareUrl(role);
      if (navigator.share) {
        navigator.share({ title: title, text: text, url: url })
          .then(function () { track('sp_role_share', { role: role, method: 'native' }); })
          .catch(function () {});
        return;
      }
      var done = function () {
        if (status) status.textContent = root.dataset.copiedLabel || 'Link copied.';
        track('sp_role_share', { role: role, method: 'copy' });
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, function () { window.prompt('', url); });
      } else {
        window.prompt('', url);
      }
    }

    function save(el) {
      var role = el.dataset.role;
      var filename = 'soft-players-role-' + role + '.png';
      var title = root.dataset.shareTitle || '';
      track('sp_card_save', { role: role });

      var imageCard = el.querySelector('[data-card-image]');
      if (imageCard) {
        var src = imageCard.getAttribute('data-card-image');
        if (src.indexOf('//') === 0) src = window.location.protocol + src;
        fetch(src)
          .then(function (r) { return r.blob(); })
          .then(function (blob) { return deliverFile(blob, filename.replace('.png', blob.type === 'image/jpeg' ? '.jpg' : '.png'), title); })
          .catch(function () { window.open(src, '_blank'); });
        return;
      }

      var cardEl = el.querySelector('[data-card]');
      if (!cardEl) return;
      var ready = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      ready.then(function () {
        var canvas = drawCard(cardEl, serif);
        canvas.toBlob(function (blob) {
          if (blob) deliverFile(blob, filename, title);
        }, 'image/png');
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-quiz-start')) {
        start();
      } else if (t.hasAttribute('data-quiz-answer')) {
        var q = t.closest('[data-screen="question"]');
        var i = questions.indexOf(q);
        answers[i] = {
          n: t.dataset.quizAnswer,
          roles: (t.dataset.roles || '').split(',').filter(Boolean).map(pad)
        };
        markSelected(i);
        track('sp_quiz_answer', { question: i + 1, answer: t.dataset.quizAnswer });
        setTimeout(function () {
          if (i + 1 < questions.length) goQuestion(i + 1);
          else showResult(score());
        }, 320);
      } else if (t.hasAttribute('data-quiz-back')) {
        if (current > 0) goQuestion(current - 1);
        else { current = -1; show(intro, true); }
      } else if (t.hasAttribute('data-quiz-restart')) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.delete('role');
          history.replaceState(null, '', u.toString());
        } catch (err) {}
        track('sp_quiz_restart');
        start();
      } else if (t.hasAttribute('data-quiz-share')) {
        share(t.closest('[data-screen="result"]'));
      } else if (t.hasAttribute('data-quiz-save')) {
        save(t.closest('[data-screen="result"]'));
      }
    });

    /* Deep links: ?role=04 shows a result, ?q1=2 answers question 1 */
    var params = new URLSearchParams(window.location.search);
    var roleParam = params.get('role');
    var q1 = params.get('q1');
    if (roleParam && findResult(roleParam)) {
      showResult(roleParam, true);
    } else if (q1 && questions[0]) {
      var btn = questions[0].querySelector('[data-quiz-answer="' + parseInt(q1, 10) + '"]');
      start();
      if (btn) btn.click();
    }

    /* Theme editor: show the selected block */
    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target;
      if (!root.contains(el) || !el.classList.contains('sp-quiz__screen')) return;
      screens.forEach(function (s) { s.hidden = s !== el; s.classList.toggle('is-active', s === el); });
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (!root.contains(e.target)) return;
      screens.forEach(function (s) { s.hidden = s !== intro; s.classList.toggle('is-active', s === intro); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sp-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
